import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { forceHttpsUri, addParamToQueryString } from 'Helpers/Uri';
import { isBrowser } from 'Helpers/Browser';

import Spinner from 'Components/layout/Spinner';

import { connect } from 'react-redux';

@connect(
    (state) => ({
        webp: state.supports.webp
    }), {}
)
export default class Picture extends React.Component {
    static propTypes = {
        webp: PropTypes.bool.isRequired,
        fullScreen: PropTypes.bool,
        url: PropTypes.string,
        resolutions: PropTypes.object,
        alt: PropTypes.string,
        forceWidth: PropTypes.string,
        forceHeight: PropTypes.string,
        onPhotoLoad: PropTypes.func,
        defaultResolution: PropTypes.number,
        maxHeight: PropTypes.number,
        supportedResolutions: PropTypes.arrayOf(
            PropTypes.shape({
                mediaQueryType: PropTypes.oneOf(['max', 'min']).isRequired,
                screenWidth: PropTypes.number.isRequired,
                photoWidth: PropTypes.number.isRequired
            })
        )
    };
    static defaultProps = {
        fullScreen: false,
        alt: ''
    }

    defaultResolution = 480;
    supportedResolutions = [
        {
            mediaQueryType: 'max',
            screenWidth: 1200,
            photoWidth: 320
        }, {
            mediaQueryType: 'max',
            screenWidth: 1600,
            photoWidth: 480
        }, {
            mediaQueryType: 'min',
            screenWidth: 1920,
            photoWidth: 640
        }
    ];

    state = {
        isLoading: true
    };

    onLoad = () => {
        if (this.props.onPhotoLoad) {
            this.props.onPhotoLoad();
        }

        this.setState({
            ...this.state,
            isLoading: false
        });
    }

    renderByImageUrl = () => {
        let { url, alt, forceWidth, forceHeight, maxHeight, webp } = this.props;
        const defaultResolution = this.props.defaultResolution || this.defaultResolution;
        const supportedResolutions = this.props.supportedResolutions || this.supportedResolutions;

        url = maxHeight ? addParamToQueryString(url, 'dh', maxHeight) : url;
        url = webp ? addParamToQueryString(url, 'of', 'webp') : url;

        let defaultSrc = addParamToQueryString(url, 'dw', defaultResolution);
        let elements = supportedResolutions.map(resolution => {
            return (<source key={resolution.photoWidth} srcSet={addParamToQueryString(url, 'dw', resolution.photoWidth)} media={`(${resolution.mediaQueryType}-width: ${resolution.screenWidth}px)`} />);
        });

        return (
            <picture>
                {elements}
                <img
                    itemProp="image"
                    className="photo"
                    onLoad={this.onLoad}
                    srcSet={defaultSrc}
                    src={defaultSrc}
                    alt={alt}
                    width={forceWidth ? forceWidth.replace('px', '') : null}
                    height={forceHeight ? forceHeight.replace('px', '') : null}
                />
            </picture>
        );
    }

    renderByResolutions = () => {
        const { resolutions, alt, forceWidth, forceHeight, fullScreen } = this.props;

        let highestResolution = 0;
        let highestResolutionSrc = null;
        let elements = Object.keys(resolutions).map(resolution => {
            let width = parseInt(resolution.split('w')[1]);
            if (!isNaN(width) && resolutions[resolution]) {

                if (width > highestResolution) {
                    highestResolution = width;
                    highestResolutionSrc = resolutions[resolution];
                }

                if (typeof resolutions[resolution] === 'string') {
                    return (<source key={resolution} srcSet={forceHttpsUri(resolutions[resolution])} media={`(max-width: ${width * (fullScreen ? 1.5 : 3)}px)`} />);
                } else {
                    return (null);
                }
            }
        });

        const altText = typeof alt === 'undefined' ? alt : '';
        const defaultSrc = forceHttpsUri(highestResolutionSrc);

        return (
            <picture>
                {elements}
                <img
                    itemProp="image"
                    className="photo"
                    onLoad={this.onLoad}
                    srcSet={defaultSrc}
                    src={defaultSrc}
                    alt={alt}
                    width={forceWidth ? forceWidth.replace('px', '') : null}
                    height={forceHeight ? forceHeight.replace('px', '') : null}
                />
            </picture>
        );
    }

    render() {
        const { isLoading } = this.state;

        if (!this.props.resolutions && !this.props.url) {
            return (null);
        }

        let picture = null;
        if (this.props.url) {
            picture = this.renderByImageUrl();
        } else if (this.props.resolutions) {
            picture = this.renderByResolutions();
        } else {
            picture = null;
        }

        return (
            <div className="component-picture">
                {isLoading && <Spinner />}
                {picture}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Picture/index.js